import { useCallback, useState } from 'react';
import { Platform } from 'react-native';
import { useFocusEffect, useRoute } from '@react-navigation/native';
import { Metric } from '../metrics';
import TENANT_ID from '../config/TenantId';
const useCurrentUri = () => {
    const { params: untypedParams } = useRoute();
    const params = untypedParams;
    let initialUri = params === null || params === void 0 ? void 0 : params.initialUri;
    if (Platform.OS === 'web') {
        initialUri = window.location.href;
    }
    const [currentUri, setCurrentUri] = useState(initialUri || '');
    const [isReady, setIsReady] = useState(false);
    useFocusEffect(useCallback(() => {
        if (initialUri) {
            setCurrentUri(initialUri);
            setIsReady(true);
        }
        else {
            Metric('UseCurrentUriFalsy', TENANT_ID).put();
        }
    }, [initialUri]));
    return { currentUri, isReady };
};
export default useCurrentUri;
//# sourceMappingURL=useCurrentUri.js.map